export const MY_SAVED_ITEMS_PAGE_SIZE = 12;
export const CREATE_PLAYLIST_ADD_TRACK_PARAM = 'addTrack';
export const CREATE_PLAYLIST_ADD_LESSON_PARAM = 'addLesson';
export const CREATE_PLAYLIST_ADD_SHORT_PARAM = 'addShort';
export const CREATE_PLAYLIST_ITEM_LANGUAGE_PARAM = 'itemLanguage';